import { useState, useEffect } from 'react';
import { clientesService } from '../../services';

const FORM_VAZIO = { nome: '', telefone: '', cpf: '', email: '', referencia: '' };

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(FORM_VAZIO);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = (b) => {
    setLoading(true);
    clientesService.listar(b ?? busca)
      .then(r => setClientes(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { carregar(''); }, []);

  const abrirNovo = () => {
    setEditando(null);
    setForm(FORM_VAZIO);
    setErro('');
    setModal(true);
  };

  const abrirEditar = (c) => {
    setEditando(c.id);
    setForm({ nome: c.nome || '', telefone: c.telefone || '', cpf: c.cpf || '', email: c.email || '', referencia: c.referencia || '' });
    setErro('');
    setModal(true);
  };

  const salvar = async () => {
    if (!form.nome.trim()) { setErro('Nome é obrigatório'); return; }
    setSalvando(true);
    setErro('');
    try {
      if (editando) {
        await clientesService.atualizar(editando, form);
      } else {
        await clientesService.criar(form);
      }
      setModal(false);
      carregar('');
      setBusca('');
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  };

  const remover = async (id, nome) => {
    if (!window.confirm(`Remover cliente "${nome}"?`)) return;
    try {
      await clientesService.remover(id);
      carregar('');
      setBusca('');
    } catch (err) {
      alert(err.response?.data?.error || 'Erro ao remover');
    }
  };

  const pesquisar = (e) => {
    e.preventDefault();
    carregar(busca);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1>👤 Clientes</h1>
        <button className="btn btn-primary" onClick={abrirNovo}>+ Novo Cliente</button>
      </div>

      <form onSubmit={pesquisar} style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <input
          type="text"
          className="form-control"
          placeholder="Buscar por nome, telefone ou CPF..."
          value={busca}
          onChange={e => setBusca(e.target.value)}
          style={{ flex: 1 }}
        />
        <button type="submit" className="btn btn-secondary">Buscar</button>
        {busca && (
          <button type="button" className="btn btn-outline" onClick={() => { setBusca(''); carregar(''); }}>
            Limpar
          </button>
        )}
      </form>

      <div className="table-container card">
        {loading ? (
          <div className="loading"><div className="spinner"></div>Carregando...</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Telefone</th>
                <th>CPF</th>
                <th>E-mail</th>
                <th>Observações</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {clientes.map(c => (
                <tr key={c.id}>
                  <td><strong>{c.nome}</strong></td>
                  <td>{c.telefone || '—'}</td>
                  <td>{c.cpf || '—'}</td>
                  <td>{c.email || '—'}</td>
                  <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {c.referencia || '—'}
                  </td>
                  <td style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-sm btn-primary" onClick={() => abrirEditar(c)}>Editar</button>
                    <button className="btn btn-sm btn-danger" onClick={() => remover(c.id, c.nome)}>Remover</button>
                  </td>
                </tr>
              ))}
              {clientes.length === 0 && (
                <tr><td colSpan="6" className="no-data">
                  {busca ? 'Nenhum cliente encontrado' : 'Nenhum cliente cadastrado'}
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => !salvando && setModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
            <h2>{editando ? 'Editar Cliente' : 'Novo Cliente'}</h2>

            <div className="form-group">
              <label>Nome *</label>
              <input
                type="text"
                className="form-control"
                value={form.nome}
                onChange={e => setForm({ ...form, nome: e.target.value })}
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>Telefone</label>
              <input
                type="text"
                className="form-control"
                value={form.telefone}
                onChange={e => setForm({ ...form, telefone: e.target.value })}
                placeholder="(00) 00000-0000"
              />
            </div>
            <div className="form-group">
              <label>CPF</label>
              <input
                type="text"
                className="form-control"
                value={form.cpf}
                onChange={e => setForm({ ...form, cpf: e.target.value })}
                placeholder="000.000.000-00"
              />
            </div>
            <div className="form-group">
              <label>E-mail</label>
              <input
                type="email"
                className="form-control"
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Observações</label>
              <input
                type="text"
                className="form-control"
                value={form.referencia}
                onChange={e => setForm({ ...form, referencia: e.target.value })}
                placeholder="Ponto de referência ou observações..."
              />
            </div>

            {erro && <p style={{ color: 'var(--danger)', marginBottom: 12 }}>{erro}</p>}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-outline" onClick={() => setModal(false)} disabled={salvando}>
                Cancelar
              </button>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
                {salvando ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
